module.exports = __webpack_public_path__ + "img/all-orders.1734f6fa.svg";